"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExternalComponents = void 0;

const ua_1 = require("../components/ua");

const webglImageHash_1 = require("../components/webglImageHash");

const webglUnmaskedRenderer_1 = require("../components/webglUnmaskedRenderer");

const webglUnmaskedVendor_1 = require("../components/webglUnmaskedVendor");

const getExternalComponents = () => __awaiter(void 0, void 0, void 0, function* () {
  return {
    userAgent: yield new ua_1.UAComponent().getComponent(),
    webglUnmaskedVendor: yield new webglUnmaskedVendor_1.WebGLUnmaskedVendorComponent().getComponent(),
    webglUnmaskedRenderer: yield new webglUnmaskedRenderer_1.WebGLUnmaskedRendererComponent().getComponent(),
    webglImageHash: yield new webglImageHash_1.WebGLImageHashComponent().getComponent()
  };
});

exports.getExternalComponents = getExternalComponents;